import KPIBrowser from "@/features/kpis/components/KPIBrowser.tsx"

export default function KPIs() {
  return (
    <div className="min-h-fit">
      <KPIBrowser />
    </div>
  )
}
